import React from "react";
import { Chart } from "react-google-charts";

const GoogleReactChart = () => {
  const data = [
    ["Country", "Value"],
    ["Germany", 200],
    ["United States", 300],
    ["Brazil", 400],
    ["Canada", 500],
    ["France", 600],
    ["India", 700],
  ];

  const options = {
    backgroundColor: "transparent",
    datalessRegionColor: "#E0E4FA", // Default color for unlisted countries
    legend: "none",
    regionColor: "#E0E4FA",
    enableRegionInteractivity: true,
    displayMode: "regions",
    enableRegionInteractivity: true,
    showOutline: false,
    colorAxis: {
      colors: ["#2B3779", "#517DDE", "#86A5E8", "#86A5E8", "#8D99DB", "#FDCC72"],
    },
  };

  return (
    <>
      <Chart
        chartType="GeoChart"
        width="100%"
        height="250px"
        data={data}
        options={options}
      />
    </>
  );
};

export default GoogleReactChart;
